import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Section extends Component {

  state = {
    section: '',
    load: false,
  }

  componentDidUpdate(props) {
    if (props.data != this.props.data) {
      this.setCategory();
    }
  }


  setCategory() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'section') {
        model.push({key: y.name, text: y.name, value: y.name});
      }
    });
    context.setState({
      sectionOption: model,
    });
    this.selected();
  }

  selected() {
    let context = this;
    var models = [];
    this.props.data.map((y) => {
      if (y.type == 'selectedsection') {
        models.push(y.name);
      }
    });
    context.setState({
      section: models,
    });
  }

  add(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Adding category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addsparesection.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  remove(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Removing category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/removesparesection.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  check(value) {
    let oldValue = this.state.section;
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      for (var i = 0; i < oldValue.length; i++) {
        if (length == 0) {
          this.remove(oldValue[i]);
          return;
        }
        for (var j = 0; j < length; j++) {
          if (oldValue[i] != value[j]) {
            this.remove(oldValue[i]);
            return;
          }
        }
      }
    }
  }

  Section = (f, { value }) => {
    this.check(value);
    this.setState({ section: value })
  }

  render() {
    let { load, message, section, sectionOption } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
      <Dropdown placeholder='Section' style={{ borderColor: '#5A9CBB' }}
       multiple search fluid selection onChange={this.Section}
       options={sectionOption} value={section} />
       {loading}
      </div>
    );
  }
}

export default Section;
